export default {
	namespaced: true,
	state: {
		loans: [],
		deposits: [],
	},

	mutations:{
		setLoans(state, payload) {
			state.loans=payload
		},

		setDeposits(state, payload) {
			state.deposits=payload
		},
	},
	getters:{
		getLoans (state) {
			return state.loans
		},


		getDeposits(state) {
			return state.deposits
		},
	},
	actions: {
		
	},

}